import { Link, Navigate } from "@tanstack/react-router";
import { IconArrowLeft } from "@synthesis/shared-icons";

import { AdminConsoleAccessGuard, AdminPageContainer, AdminSectionCard } from "../../components/admin-console/admin-console-shell";
import { useServiceDetail } from "./hooks/use-service-detail";
import { RegisterVersionModal } from "./local-components/register-version-modal";
import { ServiceDetailContent } from "./local-components/service-detail-content";
import { PageStoreProvider } from "./service-detail-page.lib";

/** ЛК администратора услуг — карточка услуги (версии процесса, комплекты документов, применение на дорогах). */
const ServiceDetailPage = () => {
  const { service } = useServiceDetail();

  if (!service) {
    return <Navigate to="/admin" />;
  }

  return (
    <AdminConsoleAccessGuard>
      <PageStoreProvider>
        <RegisterVersionModal />
        <AdminPageContainer className="gap-4">
          <Link to="/admin" className="text-type-minor hover:text-type-common flex w-fit items-center gap-2 rounded-[10px] py-2 transition-colors">
            <IconArrowLeft className="size-5" aria-hidden />
            <span className="subtitle-sm">Назад</span>
          </Link>

          <AdminSectionCard className="gap-5">
            <ServiceDetailContent />
          </AdminSectionCard>
        </AdminPageContainer>
      </PageStoreProvider>
    </AdminConsoleAccessGuard>
  );
};

export default ServiceDetailPage;
